import { render, staticRenderFns } from "./submitList.vue?vue&type=template&id=51789cd8"
import script from "./submitList.vue?vue&type=script&lang=js"
export * from "./submitList.vue?vue&type=script&lang=js"
import style0 from "./submitList.vue?vue&type=style&index=0&id=51789cd8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports